module.exports = __webpack_public_path__ + "static/media/templates.9a82c8c6.webp";